import { PaletteOptions } from '@mui/material';

export const lightPalette: PaletteOptions = {
    mode: 'light',
    background: {
        default: '#FFFFFF',
        paper: '#FFFFFF',
    },
    text: {
        primary: '#011224',
        secondary: '#808892',
    },
    primary: {
        main: '#0573E4',
    },
};
